// import GratitudeSlider from 'components/about/GratitudeSlider'
import IntLink from 'components/common/IntLink'
import { isNonEmptyArray, toPairs } from 'lib/utils'
import { useMemo } from 'react'
import {
  type IGetServicesResult,
  type IMenuItem,
  type IServicePortfolio,
} from 'store/api'
import PortfolioSlider from './PortfolioSlider'
import ServiceSuggestPopup from './ServiceSuggestPopup'
import BreadcrumbMenu from 'components/layouts/BreadcrumbMenu'

type Props = {
  menusSSR?: Record<string, IMenuItem[]>
  services: IGetServicesResult
  //thanksSSR: IGetAboutResult[]
  content: string[]
  name?: string
}

let CateringView = ({
  content,
  menusSSR = {},
  services,
  name,
}: Props) => {
  const { services: servicesList, portfolio: portfolioList } =
    services

  const groupedPortfolios = useMemo(
    () =>
      toPairs(
        portfolioList.reduce((acc, cur) => {
          acc[cur.type_label] = (acc[cur.type_label] ?? []).concat(
            cur
          )
          return acc
        }, {} as Record<IServicePortfolio['type_label'], IServicePortfolio[]>)
      ).map(([label, items]) => ({ label, items })),
    [portfolioList]
  )

  return (
    <>
      <div className='mt-4'>
        <BreadcrumbMenu menusSSR={menusSSR} />
      </div>

      <div className='custom-px'>
        <h1 className='pt-4 lg:pt-0 lg:mt-4 font-unbounded font-medium text-2xl lg:text-5xl lg:leading-tight tracking-tight'>
          {name || 'Кейтеринг'}
        </h1>
        <div
          className='mt-4 pb-8 text-base2 leading-snug text-bodyGrey border-b border-lightGrey'
          dangerouslySetInnerHTML={{ __html: content[0] ?? '' }}
        ></div>

        {isNonEmptyArray(servicesList) && (
          <>
            <div className='mt-12 font-unbounded font-bold leading-snug text-dark uppercase text-sm md:text-base'>
              События
            </div>

            <div className='mt-12 grid grid-cols-2 md:grid-cols-3 gap-x-3 gap-y-3 md:gap-x-8 md:gap-y-6 lg:gap-x-12 lg:gap-y-10 lg:grid-cols-4'>
              {servicesList.map(({ name, slug }) => (
                <div key={slug}>
                  <IntLink
                    href={`/catering/${slug}`}
                    className='group leading-tight md:leading-snug text-sm2 md:text-base text-center text-dark font-unbounded font-medium'
                  >
                    <div className='py-4 shadow-cateringSm lg:shadow-catering px-4 md:px-6 rounded-lg md:rounded-2xl'>
                      <div className='group-hover:text-accent my-4 line-clamp-2'>
                        {name}
                      </div>
                    </div>
                  </IntLink>
                </div>
              ))}
            </div>
          </>
        )}
      </div>

      {isNonEmptyArray(groupedPortfolios) && (
        <div className='custom-pl mt-20'>
          {groupedPortfolios?.map((section) => (
            <PortfolioSlider key={section.label} section={section} />
          ))}
        </div>
      )}

      <div className='sticky bottom-0 mt-12 left-0 px-0 lg:pr-0 lg:pr-12 xl:pr-24 2xl:pr-48 lg:pl-12 xl:pl-24 2xl:pl-48 md:mb-12 z-[11]'>
        <ServiceSuggestPopup />
      </div>
    </>
  )
}

export default CateringView
